import {NgModule} from '@angular/core';
import {pristineCountdownComponent} from "./countdown.component";


@NgModule({
  declarations: [
    pristineCountdownComponent
  ],
  exports: [
    pristineCountdownComponent
  ],
})
export class pristineCountdownModule {
}
